<template>
  <div>
    <label class="fox-label--simple">
      Absender <span class="fox-input__require-star">*</span>
    </label>
    <div>
      <input type="text"
             v-model="senderLocal.name"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.name"
             v-bind:class="classes.name"
      >
    </div>
    <div class="tw-mt-2">
      <input type="text"
             v-model="senderLocal.street"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.street"
             v-bind:class="classes.street"
      >
    </div>
    <div class="tw-mt-2 tw-flex">
      <input type="text"
             v-model="senderLocal.postalCode"
             class="fox-input--simple tw-w-full mr-2"
             :placeholder="placeholder.postalCode"
             v-bind:class="classes.postalCode"
      >
      <input type="text"
             v-model="senderLocal.city"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.city"
             v-bind:class="classes.city"
      >
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    sender: {
      type: Object
    }
  },
  data: function () {
    return {
      senderLocal: { ...this.sender },
      placeholder: {
        name: 'Name',
        street: 'Straße und Hausnummer',
        postalCode: 'PLZ',
        city: 'Stadt'
      }
    }
  },
  validations () {
    return {
      senderLocal: {
        name: { required },
        street: { required },
        postalCode: { required },
        city: { required }
      }
    }
  },
  computed: {
    classes: function () {
      return {
        name: {
          'fox-input--error': this.v$.senderLocal.name.$error
        },
        street: {
          'fox-input--error': this.v$.senderLocal.street.$error
        },
        postalCode: {
          'fox-input--error': this.v$.senderLocal.postalCode.$error
        },
        city: {
          'fox-input--error': this.v$.senderLocal.city.$error
        }
      }
    }
  },
  watch: {
    sender: {
      handler(newVal) {
        this.senderLocal = { ...newVal }
      },
      deep: true
    },
    'senderLocal.name'() {
      this.$emit('update', this.senderLocal)
    },
    'senderLocal.street'() {
      this.$emit('update', this.senderLocal)
    },
    'senderLocal.postalCode'() {
      this.$emit('update', this.senderLocal)
    },
    'senderLocal.city'() {
      this.$emit('update', this.senderLocal)
    }
  }
}
</script>
